import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

interface ConflictRow {
  id: number;
  slug: string;
  field_path: string;
  pfm_value: string;
  official_value: string;
  resolved: number;
  detected_at: number;
}

export function ConflictsPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["admin", "conflicts"],
    queryFn: () => api.get<{ conflicts: ConflictRow[] }>("/api/admin/conflicts"),
  });

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">Rule conflicts</h1>
      <p className="text-sm text-muted-foreground">
        Disagreements between propfirmmatch.com and a firm's official site. The
        compliance engine already prefers source=official, so these are
        informational — but you should review and resolve them.
      </p>
      <div className="pfh-card overflow-x-auto">
        {isLoading ? (
          <div className="text-muted-foreground">loading…</div>
        ) : (data?.conflicts?.length ?? 0) === 0 ? (
          <div className="text-muted-foreground">no conflicts detected — nice.</div>
        ) : (
          <table className="w-full text-xs">
            <thead>
              <tr className="pfh-heading text-left">
                <th className="py-2">Slug</th>
                <th>Field</th>
                <th>propfirmmatch</th>
                <th>official</th>
                <th>Detected</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody className="font-mono">
              {data!.conflicts.map((c) => (
                <tr key={c.id} className="border-t border-border/60">
                  <td className="py-2">{c.slug}</td>
                  <td>{c.field_path}</td>
                  <td className="text-yellow-400">{c.pfm_value}</td>
                  <td className="text-green-400">{c.official_value}</td>
                  <td className="text-muted-foreground">
                    {new Date(c.detected_at).toLocaleDateString()}
                  </td>
                  <td>{c.resolved ? "✓ resolved" : "open"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
